module.exports = __webpack_public_path__ + "media/bg_police_04.c9b1d0d8.mp4";